import { render, staticRenderFns } from "./scanQR-socoBeautyStar.html?vue&type=template&id=12121740&scoped=true&"
import script from "./scanQR.vue?vue&type=script&lang=js&"
export * from "./scanQR.vue?vue&type=script&lang=js&"
import style0 from "./scanQR.vue?vue&type=style&index=0&id=12121740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12121740",
  null
  
)

export default component.exports